import axios from "axios";
import { REACT_APP_BASE_PATH } from "../config/runtimeConfig";
import { getAccessToken, logout } from "../services/sessionAuth";

export const BASE_PATH = REACT_APP_BASE_PATH.replace(/\/+$/, "");

const client = axios.create({
  baseURL: BASE_PATH,
  headers: { "Content-Type": "application/json" },
});

client.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error?.response?.status === 401) {
      await logout();
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export async function getData<T>(path: string): Promise<T> {
  const res = await client.get<T>(path);
  return res.data;
}

export async function postData<T>(path: string, body?: unknown): Promise<T> {
  const res = await client.post<T>(path, body);
  return res.data;
}

export async function deleteData(path: string): Promise<void> {
  await client.delete(path);
}
